module.exports = __webpack_public_path__ + "static/media/discount-forwarding-1.fd81480a.png";